import { cn } from '@/lib/utils';

interface LogoProps {
  /** Size the wordmark with an h-* class; width scales automatically. */
  className?: string;
}

/**
 * Recovry wordmark — the official brand logo in its exact typeface, recoloured
 * to the brand teal on a transparent background. Two variants swap by theme:
 * dark teal on light backgrounds, lighter teal on dark backgrounds.
 */
export function Logo({ className }: LogoProps) {
  return (
    <>
      <img
        src="/recovry-wordmark.png"
        alt="Recovry"
        width={1229}
        height={287}
        className={cn('h-8 w-auto select-none dark:hidden', className)}
      />
      <img
        src="/recovry-wordmark-dark.png"
        alt=""
        aria-hidden="true"
        width={1229}
        height={287}
        className={cn('hidden h-8 w-auto select-none dark:block', className)}
      />
    </>
  );
}
